import { render, staticRenderFns } from "./Subspecialties.vue?vue&type=template&id=0b6b5470&scoped=true"
import script from "./Subspecialties.vue?vue&type=script&lang=js"
export * from "./Subspecialties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b5470",
  null
  
)

export default component.exports